module.exports = "<!-- <div *ngIf=\"loader.ISLOADING | async\" class=\"loader\" style=\"background-image: url('https://s3.amazonaws.com/acep-assets/global/process.gif')\"></div> -->\r\n<div *ngIf=\"loader.ISLOADING | async\" class=\"loader\" style=\"background-image: url('./assets/_images/process.gif')\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/loader/loader.component.html
// module id = 6G1J
// module chunks = 7